import React from 'react'

export function Oricdata2() {
  return (
    <div>
      <h1>Introduction</h1>
      <p> What is Lorem Ipsum?
Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
      </p>
    </div>
  )
}


export function Oricdata3() {
  return (
    <div>
      <h1>Mission and Vision</h1>
      <p> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. 
      </p>
    </div>
  )
}

export function Oricdata4() {
  return (
    <div>
      <ul>
    <h3>Vision:</h3>
    <li>EIMS,QEC goal is to provide an innovative quality education by ensuring well-matched with national standards.</li>
    <h3>Mission Statement:</h3>
    <li>EIMS,QEC is dedicated and committed to guarantee and extend superiority in higher education with regards to unified teaching methodologies, having a good environment, and feedback-based education, positive students’ perception, effective programs assessment tools and a learning environment encouraging research culture.</li>
  </ul>
    </div>
  )
}

// export default function Oricdata() {
//   return (
//     <div>
//       <Oricdata2/>
//       <Oricdata3/>
//       <Oricdata4/>
//     </div>
//   );
// }